// import Swiper JS
import Swiper, { Autoplay, Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation]);

export function initTeamCarousel() {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=team_carousel',
      teamCarousel
    );
  }
}

export function teamCarousel() {
  if (!document.querySelector('.team-carousel')) return;

  let totalSlides = document.querySelectorAll(
    '.team-carousel > .swiper .swiper-slide'
  ).length;

  const teamCarousel = new Swiper('.team-carousel > .swiper', {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      // when window width is >= 640px
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
    autoplay: {
      delay: 7000,
    },
    spaceBetween: 20,
    navigation: {
      nextEl: '.card-carousel-prev',
      prevEl: '.card-carousel-next',
    },
  });
}
